import React, {useContext, useEffect, useRef, useState} from 'react'
import {SessionContext} from 'Utils/sessions';
import s from './styles/Dashboard.module.scss'
import SideBar from 'Components/Nav/SideBar';
import {setSessionCookie} from "../Utils/sessions";
import {AdminApi} from "../Api/AdminApi";
import {useLocation} from "react-router-dom";
import {Tile} from "../Components/Tile/Tile";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const MainDashboard = () => {
    const {session} =  useContext(SessionContext);
    const [summaryPageData, setSummaryPageData] = useState(null);
    const [systemHealth, setSystemHealth] = useState(null); // String
    const [systemLogs, setSystemLogs] = useState(null); // String
    const [systemErrors, setSystemErrors] = useState(null); // List<SystemError>
    const [errorDetails, setErrorDetails] = useState(undefined)
    const [showSystemHealth, setShowSystemHealth] = useState(false)
    const [showSystemLogs, setShowSystemLogs] = useState(false)
    const [showErrorDetails, setShowErrorDetails] = useState(false)
    const pathname = useLocation().pathname

    useEffect(() => {
        AdminApi.User.getAdminPageSummaryData({}, session.jwt).then(res => {
            setSummaryPageData(res.data);
        }).catch(error => {
            if (error.message?.includes( '404')) {
                setSessionCookie({})
                window.location.href = window.location.hostname
            }
        })
    }, [session.jwt])

    useEffect(() => {
        AdminApi.Support.getSystemInformation({}, session.jwt).then(res => {
            setSystemHealth(res.data?.health);
            setSystemLogs(res.data?.logs);
            setSystemErrors(res.data?.errors);
        }).catch(error => {
            if (error.message?.includes( '404')) {
                setSessionCookie({})
                window.location.href = window.location.hostname
            }
        })
    }, [session.jwt])

    useEffect(() => {
        if (!pathname.startsWith("/dashboard")) {
            window.location.replace('/dashboard')
        }
    }, [pathname])

    const hideSystemHealth = () => {
        setShowSystemHealth(false)
    }

    const hideSystemLogs = () => {
        setShowSystemLogs(false)
    }

    const hideErrorDetails = () => {
        setErrorDetails(undefined)
        setShowErrorDetails(false)
    }

    const reloadPage = () => {
        window.location.reload()
    }

    return <div>
        <SideBar session={session} title={"Dashboard"}>
            <div className={s.adminDashboard}>
                <main>
                    <h3 className='heading'>System</h3>
                    <SystemHealthModal systemHealth={systemHealth}
                                       showSystemHealth={showSystemHealth}
                                       hideSystemHealth={hideSystemHealth}/>
                    <SystemLogsModal systemLogs={systemLogs}
                                     showSystemLogs={showSystemLogs}
                                     hideSystemLogs={hideSystemLogs}/>
                    <SystemErrorDetailsModal errorDetails={errorDetails}
                                             showErrorDetails={showErrorDetails}
                                             hideErrorDetails={hideErrorDetails}
                                             reloadPage={reloadPage}/>
                    <div className={s.viewModalButtonContainer}>
                        <div onClick={() => {
                            setShowSystemLogs(true)
                        }} className={`${s.createCampaignCard}`}>
                            <div className={s.createCampaignCardBody}>
                                View System Logs
                            </div>
                        </div>

                        <div onClick={() => {
                            setShowSystemHealth(true)
                        }} className={`${s.createCampaignCard}`}>
                            <div className={s.createCampaignCardBody}>
                                View System Health
                            </div>
                        </div>
                    </div>
                    <div className={s.errorListContainer}>
                        <div className={s.elementList}>
                            {systemErrors ? systemErrors.map((errorDetails) =>
                                    <SystemErrorCard errorDetails={errorDetails} viewErrorDetails={() => {
                                        setErrorDetails(errorDetails)
                                        setShowErrorDetails(true)
                                    }}/>
                                ) :
                                <>
                                    <SystemErrorCard/>
                                    <SystemErrorCard/>
                                    <SystemErrorCard/>
                                    <SystemErrorCard/>
                                    <SystemErrorCard/>
                                </>
                            }
                        </div>
                    </div>

                    <h3 className='heading mt-4'>Summary</h3>
                </main>
            </div>
        </SideBar>
    </div>
}

const SystemErrorCard = ({errorDetails, viewErrorDetails}) => {
    return <div onClick={viewErrorDetails} className={`${s.errorCard}`}>
        {errorDetails ?
            <>
                <p className={'mt-2 mb-3 fw-bold'}
                   style={{fontSize: '15px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                    {errorDetails.errorMessage}
                </p>
            </> :
            <>
                <div className={`${s.textPlaceHolder} ${s.shimmerBg}`}></div>
            </>
        }

        {errorDetails ?
            <>
                <p className={'mt-2 mb-3'}
                   style={{fontSize: '15px', overflow: 'hidden', textOverflow: 'ellipsis'}}>
                    <strong>URI: </strong> {errorDetails.requestURI}
                </p>
            </> :
            <>
                <div className={`${s.textPlaceHolder} ${s.shimmerBg}`}></div>
            </>
        }

        {errorDetails ?
            <>
                <Tile width={'100%'} fontSize={'0.8em'} color={'green'}><strong>{new Date(errorDetails.timeOfOccurrence).toLocaleDateString()} at {new Date(errorDetails.timeOfOccurrence).toLocaleTimeString()}</strong></Tile>
            </> :
            <>
                <div className={`${s.textPlaceHolder} ${s.shimmerGreen} mb-2`}></div>
            </>
        }
    </div>
};

const SystemHealthModal = ({ systemHealth, showSystemHealth, hideSystemHealth }) => {
    const scrollableDivRef = useRef(null);

    useEffect(() => {
        const div = scrollableDivRef.current;
        if (div) {
            div.scrollTop = div.scrollHeight;
        }
    }, [systemHealth]);

    return <Modal fullscreen={'lg-down'} size={'lg'} show={showSystemHealth} onHide={()=> {hideSystemHealth()}}>
        <Modal.Header closeButton/>
        <Modal.Title>
            <h3 style={{textAlign: 'center'}}>System Health</h3>
        </Modal.Title>
        <Modal.Body>
            <div ref={scrollableDivRef} className={s.interactionLogList}>
                {systemHealth}
            </div>
        </Modal.Body>
    </Modal>
};


const SystemLogsModal = ({ systemLogs, showSystemLogs, hideSystemLogs }) => {
    const scrollableDivRef = useRef(null);

    useEffect(() => {
        const div = scrollableDivRef.current;
        if (div) {
            div.scrollTop = div.scrollHeight;
        }
    }, [systemLogs]);


    return <Modal fullscreen={'xl-down'} size={'xl'} show={showSystemLogs} onHide={()=> {hideSystemLogs()}}>
        <Modal.Header closeButton/>
        <Modal.Title>
            <h3 style={{textAlign: 'center'}}>System Logs</h3>
        </Modal.Title>
        <Modal.Body>
            <div ref={scrollableDivRef} className={s.interactionLogList}>
                {systemLogs}
            </div>
        </Modal.Body>
    </Modal>
};

const SystemErrorDetailsModal = ({ errorDetails, showErrorDetails, hideErrorDetails, reloadPage }) => {
    const {session} = useContext(SessionContext)

    const archiveSystemError = (id) => {
        AdminApi.Support.archiveSystemError({id}, session.jwt).then(res => {
            reloadPage()
        }).catch(error => {
            if (error.message?.includes( '404')) {
                setSessionCookie({})
                window.location.href = window.location.hostname
            }
        })
    }

    return <Modal fullscreen={'xxl-down'} size={"xl"} show={showErrorDetails} onHide={()=> {hideErrorDetails()}}>
        <Modal.Header closeButton/>
        <Modal.Title>
            <h3 style={{textAlign: 'center'}}>Error Details</h3>
        </Modal.Title>
        <Modal.Body>
            <p className={'mb-3 text-muted text-center'}>{errorDetails?.elementId}</p>
            <div className={s.interactionLogList}>
                {errorDetails &&
                    <>
                        <div className={s.errorLogEntry}>
                            <p style={{fontSize: '15px', whiteSpace: 'inherit', overflowWrap: 'break-word'}} className={'mt-3 mb-2'}>
                                <strong>Error ID:</strong> {errorDetails.id}
                            </p>

                            {errorDetails.affectedUsername &&
                                <p style={{fontSize: '15px', whiteSpace: 'inherit', overflowWrap: 'break-word'}} className='mb-2'>
                                    <strong>Affected Username:</strong> {errorDetails.affectedUsername}
                                </p>
                            }
                            {errorDetails.requestJWT &&
                                <p style={{fontSize: '15px', whiteSpace: 'inherit', overflowWrap: 'break-word'}} className='mb-2'>
                                    <strong>Request JWT:</strong> {errorDetails.requestJWT}
                                </p>
                            }

                            {errorDetails.requestURI &&
                                <p style={{fontSize: '15px', whiteSpace: 'inherit', overflowWrap: 'break-word'}} className='mb-2'>
                                    <strong>Request URI:</strong> {errorDetails.requestURI}
                                </p>
                            }

                            {errorDetails.errorMessage &&
                                <p style={{fontSize: '15px', whiteSpace: 'inherit', overflowWrap: 'break-word'}} className='mb-2'>
                                    <strong>Error Message:</strong> {errorDetails.errorMessage}
                                </p>
                            }

                            {errorDetails.stackTrace &&
                                <>
                                    <p style={{fontSize: '15px', whiteSpace: 'inherit', overflowWrap: 'break-word'}} className='mb-2'>
                                        <strong>Stack Trace:</strong> {errorDetails.stackTrace}
                                    </p>
                                </>

                            }
                        </div>
                    </>
                }
            </div>
        </Modal.Body>
        <Modal.Footer>
            <Button className={`btn-danger md wide ${s.modalFooterButton}`} onClick={() => {
                archiveSystemError(errorDetails.id)
            }}>
                Archive Error
            </Button>
        </Modal.Footer>
    </Modal>
};

export default (MainDashboard);
